const ColorSchemes = require("./calendar-color-schemes");
const BooleanInput = require("app/shared/components/BooleanInput/boolean-input");

const CalendarLegend = React.createClass({
  getInitialState: function() {
    return ({ colorScheme: this.props.colorScheme });
  },

  changeTo: function(colorScheme) {
    this.setState({ colorScheme: colorScheme }, function() {
      this.props.updateColorScheme(colorScheme);
    });
  },

  render: function() {
    return (
      <div className="bootstrap-agendor fs-12 m-30">
        {ColorSchemes.map(colorScheme =>
          <div key={colorScheme.name} className="mb-20">
            <div className="d-ib c-pointer" onClick={() => this.changeTo(colorScheme)}>
              <div className="d-ib va-mid">
                <BooleanInput
                  type="radioButton"
                  checked={this.state.colorScheme === colorScheme}
                />
              </div>
              <span className="va-mid ml-10">{colorScheme.label}</span>
            </div>

            <div className="mt-10">
              {Array.from(colorScheme.mapping).map(([name, { label, color }]) =>
                <div className="d-ib mr-20" key={name}>
                  <span
                    className="d-ib w-20 h-20 mr-10 va-mid"
                    style={{backgroundColor: color}}
                  />
                  <span className="va-mid">{label}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
});

module.exports = CalendarLegend;


// WEBPACK FOOTER //
// ./app/screens/Activity/components/Calendar/calendar-legend.jsx